// Styles for MerchandisingDCAContainer go here.
import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledMerchandisingDCAContainer = styled.div`
  .container-component > div.aem-container {
    padding: 0;
    max-width: 100% !important;
  }

  // this style is needed when we author ANY hero variation inside this dca container
  .heroBanner_background_image {
    object-fit: cover !important;
  }

  &.skeleton-loader-composite {
    // allow the background color to be overridden by the CSS variable; or use default value if not set
    background-color: var(--cobrand-skeleton-loader-bg-overwrite, #d2d2d2);
    color: ${baseVariables.color.merch50};
    -webkit-animation: fadein 1s ease-in alternate infinite;
    -moz-animation: fadein 1s ease-in alternate infinite;
    animation: fadein 1s ease-in alternate infinite;
    border-radius: 8px;
  }
  @-webkit-keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  @-moz-keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  @keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
`;
